module.exports = __webpack_public_path__ + "img/16849.a1bf34ce.png";